<div *ngIf="(question?.imageBase64) else loading" class="warp-image">
    <img class="image" [src]="question?.imageBase64" alt="Image">
</div>
<ng-template #loading>
    <div *ngIf="question?.statusImage==enumImageStatus.Load else noImage" class="load-warp">
       <div class="load-item"></div>
    </div>
</ng-template>
<ng-template #noImage>
    <que-image *ngIf="!isUser$()" [isDisplay]="true"></que-image>
</ng-template>